export default () => ({
  devices: {},
  devicesPromise: null,
  disconnectedLocationHistory: {},
});
